import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import LazyAnimation from './LazyAnimation';

const useStyles = makeStyles({
  wrapper: {
    backgroundColor: '#B3B3B3',
    position: 'relative',
    '&::after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      boxShadow: '0px 12px 18px -6px rgba(0, 0, 0, 0.3)',
      pointerEvents: 'none',
    },
  },
  container: {
    paddingTop: 27,
    paddingBottom: 27,
    width: '80%',
    maxWidth: 1080,
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  buttonRoot: {
    color: '#0C71C3',
    borderRadius: 4,
    letterSpacing: 2,
    marginBottom: 8,
    fontSize: 12,
    fontFamily: 'MontserratSemiBold',
    fontWeight: '600',
    textTransform: 'uppercase',
    backgroundColor: 'transparent',
    border: '2px solid #0C71C3',
    lineHeight: '1.7em',
    padding: '12px 1em',
    transition: 'all 300ms ease 0ms',
    position: 'relative',
    boxShadow: '0px 2px 18px 0px rgba(0,0,0,0.3)',
    '& > svg': {
      position: 'absolute',
      opacity: 0,
      marginLeft: '-1em',
      transition: 'all 300ms ease 0ms',
      height: '0.8em',
      right: 4,
      color: '#0C71C3',
    },
    '&:hover': {
      backgroundColor: 'hsla(0,0%,100%,.2)',
      paddingRight: '2.2em',
      paddingLeft: '0.7em',
      '& > svg': {
        opacity: 1,
        marginLeft: 0,
      },
    },
  },
  helper: {
    fontFamily: 'OpenSansRegular',
    fontSize: 14,
    fontWeight: '500',
    color: '#0C71C3',
    lineHeight: '1.7em',
    textAlign: 'center',
  },
});

function Individuals({ onPageExit }) {
  const classes = useStyles();

  return (
    <section id="for-individuals">
      <LazyAnimation type="translate-bottom-80 fade-in">
        <div className={classes.wrapper}>
          <div className={classes.container}>
            <ButtonBase
              component={Link}
              classes={{ root: classes.buttonRoot }}
              disableRipple
              to="/signup"
              onClick={() => onPageExit('/signup', 'for-individuals')}
            >
              For individuals
              <ChevronRightIcon />
            </ButtonBase>
            <Typography className={classes.helper}>
              Register to Start Your Journey
            </Typography>
          </div>
        </div>
      </LazyAnimation>
    </section>
  );
}

Individuals.propTypes = {
  onPageExit: PropTypes.func,
};

export default Individuals;
